export default {
  MinDate: '{name} باید بعد از {min} باشد',
  MaxDate: '{name} باید قبل از {max} باشد',
  digit: '{name} باید عدد باشد',
  carSelectionIsRequired: 'انتخاب خودرو الزامی است',
  packageSelectionIsRequired: 'انتخاب بسته بندی الزامی است',
  required: '{field} الزامی است',
  min: '{field} باید حداقل {length} کاراکتر باشد',
  max: '{field} باید حداکثر {length} کاراکتر باشد',
  length: '{field} باید دقیقا {length} کاراکتر باشد',
  minValue: 'مقدار {field} نمی تواند کمتر از {value} باشد',
  maxValue: 'مقدار {field} نمی تواند بیشتر از {value} باشد',
  notValid: '{field} معتبر نیست',
  confirmed: 'مقدار {field} باید با {source} یکسان باشد',
  registerOrderInterval:
    '{field} باید حداقل {intervalHours} ساعت بعد از ساعت فعلی باشد',
  carLaborerCount: {
    min: 'حداقل تعداد کارگر برای هر {carTitle} {count} نفر می باشد'
  },
  carSelectionIsRequired: 'برای ادامه انتخاب حداقل یک خودرو الزامی است',
  packageSelectionIsRequired: 'برای ادامه انتخاب حداقل یک بسته الزامی است',
  technicalForceSelectionIsRequired:
    'برای ادامه انتخاب حداقل یک نیروی فنی الزامی است'
}
